import React, { PropsWithChildren, useRef } from 'react';
interface ownProps {
  isLoading: boolean;
  action: any;
  isEmpty: boolean;
  disabled: boolean;
  styles: any;
}
const InfiniteScroll: React.FC<PropsWithChildren & ownProps> = ({
  children,
  isLoading,
  action,
  isEmpty,
  disabled,
  styles,
}) => {
  const myRef = useRef<HTMLInputElement>(null);
  const handleScroll = (e: any) => {
    if (myRef.current) {
      let element = e.target;

      const scrollTop = myRef.current.scrollTop;
      // Bails early if:
      if (isLoading || isEmpty || !myRef || disabled) {
        return;
      }
      // Checks that the page has scrolled to the bottom
      if (element.scrollHeight - window.innerHeight <= scrollTop) {
        action();
      }
    }
  };

  return (
    <div
      ref={myRef}
      onScroll={handleScroll}
      className={styles.InfiniteScrollWrapper}
    >
      {children}
    </div>
  );
};

export default InfiniteScroll;
